import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import { TableHead } from '../../../components/ui/table';

import type { SortDirection } from '../types/account-stats';
import type { JSX, ReactNode } from 'react';

type SortableTableHeaderProps<K extends string> = {
  label: string;
  sortKey: K;
  currentKey: K;
  direction: SortDirection;
  onSort: (key: K) => void;
  align?: 'start' | 'end';
  className?: string;
  extra?: ReactNode;
};

function SortIcon({
  isActive,
  direction,
}: {
  isActive: boolean;
  direction: SortDirection;
}): JSX.Element {
  if (!isActive) return <ArrowUpDown className="size-3.5 text-muted-foreground/50" />;
  if (direction === 'asc') return <ArrowUp className="size-3.5 text-primary" />;
  return <ArrowDown className="size-3.5 text-primary" />;
}

export function SortableTableHeader<K extends string>({
  label,
  sortKey,
  currentKey,
  direction,
  onSort,
  align = 'end',
  className = '',
  extra,
}: SortableTableHeaderProps<K>): JSX.Element {
  const isActive = sortKey === currentKey;
  const justify = align === 'start' ? 'justify-start' : 'justify-end';

  return (
    <TableHead
      className={`cursor-pointer select-none whitespace-nowrap bg-background ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <div className={`flex items-center ${justify} gap-1`}>
        <span className={isActive ? 'text-foreground' : ''}>{label}</span>
        <SortIcon isActive={isActive} direction={direction} />
        {extra && (
          <span className="inline-flex" onClick={e => e.stopPropagation()}>
            {extra}
          </span>
        )}
      </div>
    </TableHead>
  );
}
